<template lang="pug">
  div
    section.content-header
      h1 {{page_title}}

      ol.breadcrumb
        li
          router-link(:to="{name: 'top'}")
            span.glyphicon.glyphicon-home
            | TOP
        li
          router-link(:to="{name: 'pvtag'}") 個人タグ管理
        li.active {{page_title}}

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit") {{action_name}}
            |
            |
            router-link.btn.btn-default(:to="{name: 'pvtag'}") キャンセル
            template(v-if="this.id")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button" @click="isModalConfOpen = true") 削除

        +btnbar

        .box.box-widget

          .box-body
            .form-group
              label.control-label(for="bcard-tag-details-name") タグ名
                span.bcard-required (*)
              input#bcard-tag-details-name.form-control(type="text", v-model="item.name", :maxlength="maxlengths.name", required)

            .form-group
              label.control-label(for="bcard-tag-details-color") タグカラー
              select-tag-color(v-model="item", type="pvtag")

            .form-group
              label.control-label(for="bcard-tag-details-memo") メモ
              input#bcard-tag-details-memo.form-control(type="text", v-model="item.memo", :maxlength="maxlengths.memo")

            p.bcard-required ※ (*)は必須項目です。

        +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(type="danger" v-model="isModalConfOpen")
      template(slot="title") 個人タグ情報の削除
      h4 個人タグ情報を削除します。よろしいですか？
      p.bcard-comments.text-info ※ 名刺人物に登録されている場合、名刺人物からも削除されます。
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(type="button" @click="close(); delTag();") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import selectTagColor from '@/components/organisms/TagEditColor'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PvtagRepository = RepositoryFactory.get('pvtag')

export default {
  name: 'PvtagEdit',
  components: { AppModal, AppMessages, selectTagColor },
  mixins: [ mixinForm ],
  props: {
    id: {type: [String, Number], required: false, default: null},
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          name: '',
          color: '',
          color_rgb: '',
          memo: '',
          openflag: '0'
        }
      }
    }
  },
  data: function () {
    return {
      page_title: this.id ? '個人タグ情報の変更' : '個人タグ情報の作成',
      action_name: this.id ? '変更' : '作成',
      isModalConfOpen: false,
      maxlengths: {}
    }
  },
  created: function () {
    const vm = this
    this.maxlengths = this.loadMaxlengths('Pvtags')
    // 変更時の初期データ
    if (this.id) {
      // API実行
      PvtagRepository.get(this.id)
        .then(function (response) {
          let tag = vm.getApiData(response).data
          vm.item.name = tag.name
          vm.item.color = tag.color
          vm.item.color_rgb = tag.color_rgb
          vm.item.memo = tag.memo
          vm.$forceUpdate()
        })
        .catch(function (error) {
          // データが無い場合は一覧へ
          vm.setErrorMessage(error)
          vm.$router.push({name: 'pvtag'})
          vm.$store.commit('setFlashMessages', vm.errors)
        })
    }
  },
  methods: {
    delTag: function () {
      const vm = this

      // 削除API実行
      PvtagRepository.delete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'pvtag'})

          // 例外発生する？
          }
          else {
            // eslint-disable-next-line no-console
            console.log(response)
          }
        })

        // エラー時処理
        .catch(function (error) {
          vm.errors.push(vm.setErrorMessage(error))
        })
    },
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this
      let params = {}
      let repos

      // 登録内容
      params = {
        name: this.item.name,
        color: this.item.color,
        memo: this.item.memo
      }

      // 更新オプション
      if (this.id) {
        repos = PvtagRepository.put(this.id, params)
        // 作成オプション
      }
      else {
        repos = PvtagRepository.post(params)
      }

      // API実行
      repos
      // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'pvtag'})
          }
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/prsettings/pvtag/Edit.vue